import { DeleteRequest, GetListRequest, GetListResponse } from "./api.model";

export type TemplateGetListRequest = GetListRequest<TemplateGetListRequestFilter>;
export type TemplateGetListResponse = GetListResponse<Template>;
export type TemplateDeleteRequest = DeleteRequest;

export interface TemplateGetListRequestFilter {
  title?: string | null;
  code?: string | null;
  refEvent_Code?: string | null;
  isEnabled?: boolean | null;
}

export interface Template {
  code: string;
  description?: string | null;
  template_Translations: TemplateTranslationInsertRequest[];
  refEvent_Code?: string | null;
  isEnabled?: boolean | null;
  templateType?: TemplateType;
  masterTemplate_Name?: string | null;
  isGenric?: boolean | null;
  isMaster?: boolean | null;

  /** @format int64 */
  sortOrder?: number | null;

  /** @format int64 */
  refOrganization_Id?: number | null;
  isVisibleToOrg?: boolean | null;

  /** @format int64 */
  id?: number;
  title?: string | null;
  templateType_Name?: string | null;
  event_Name?: string | null;

  /** @format byte */
  system_RowVersion?: string | null;
}

export type TemplateType = 1 | 2;

export interface TemplateTranslationInsertRequest {
  title: string;
  body: string;
  description?: string | null;

  /** @format int64 */
  refLanguage_Id: number;
}
